import { CheckBox } from "../../../../core/components/CheckBox";
import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";

export const RenderTop = ({ handleCheckboxEquitativeChange, isOnly }: { handleCheckboxEquitativeChange: (newSelectedValues: string[]) => void; isOnly: boolean }) => {
	return (
		<Column
			crossAxisAlignment="start"
			mainAxisAlignment="start"
			className="gap-1"
			flexible
		>
			<CheckBox
				className={`select-none underline cursor-pointer font-bold ${isOnly ? "text-orange-500" : "text-orange-300"}`}
				initialValue={["lotteryEquitative"]}
				items={[
					{
						label: "¿Quieres que cada participante reciba un solo premio? (hasta agotarlos)",
						value: "lotteryEquitative",
					},
				]}
				onChange={handleCheckboxEquitativeChange}
			/>
			{/* <TextComponent
				variant="h6"
				className="text-orange-800"
			>
				Si hay más premios que participantes: Cada participante recibe un solo premio hasta que se acaben los participantes.
				<br />
				Si hay más participantes que premios: Cada participante recibe un premio hasta que se acaben los premios.
			</TextComponent> */}
			<TextComponent
				variant="h5"
				className="text-gray-700 text-start"
			>
				Para <strong>agregar</strong> participantes o premios, <strong>sepáralos</strong> con <strong>comas</strong> o <strong>presiona Enter</strong>.
			</TextComponent>
		</Column>
	);
};
